import http from "./http";

export type MeResponse = {
  id: string;
  role: string;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
  lang?: string;
};

export async function fetchSession(): Promise<MeResponse | null> {
  try {
    const res = await http.get("/auth/me");
    return res?.data?.data ?? null;
  } catch {
    return null;
  }
}
